export const config = {
  title: "American Realty of PSL, LLC",
  meta: {
    description:
      "American Realty of PSL, LLC, led by Realtor Islayne Richart, specializes in helping buyers, sellers, and renters navigate real estate in Port St. Lucie, FL and surrounding areas.",
    keywords: [
      "American Realty of PSL",
      "Port St Lucie real estate",
      "Islayne Richart Realtor",
      "Port St Lucie homes for sale",
      "Florida real estate agent"
    ],
    author: "American Realty of PSL, LLC",
    canonicalUrl: "https://www.islaynesellsrealestate.com/",
  },
  sections: {
    header: { businessName: "American Realty of PSL, LLC" },
    sectionB: {
      heroTitle: "American Realty of PSL, LLC",
      heroSubtitle: "Your Trusted Realtor in Port St. Lucie, FL",
      learnAboutText: "Search for Homes",
      phoneNumber: "7573003774",
      phoneLabel: "(757) 300‑3774",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1297933336/photo/asian-chinese-real-estate-agent-handling-house-keys-to-happy-chinese-couple-at-their-new-house.jpg?s=612x612&w=0&k=20&c=lis6mmaBq2uXK6rtYhiOehtDVA3_XjrxIWaHWal33jU=",
      cardData: [
        {
          title: "Buyers & Sellers",
          description:
            "Expert guidance for buying or selling homes in Port St. Lucie.",
        },
        {
          title: "Renters & Landlords",
          description: "Navigate rental markets with confidence.",
        },
        {
          title: "Free Home Evaluations",
          description: "Know the true value of your home before selling.",
        },
      ],
      description:
        "Led by Realtor Islayne Richart, American Realty of PSL helps buyers, sellers, and renters navigate Port St. Lucie property markets with expert service and personalized guidance.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Full-service real estate support for purchase, sale, rental, and home evaluation.",
      cards: [
        {
          title: "Home Buying",
          description:
            "Find homes that suit your lifestyle in Port St. Lucie.",
          imageSrc: "https://media.istockphoto.com/id/2139010213/photo/real-estate-agent-showing-a-young-couple-a-new-house.jpg?s=612x612&w=0&k=20&c=VSYwa5eAIVm9vC0rFCihmDbUje09IY1fODkjmplRnCM=",
          imageAlt: "Home Buying",
        },
        {
          title: "Home Selling",
          description:
            "Maximize your home's value with strategic marketing.",
          imageSrc: "https://media.istockphoto.com/id/2198966747/photo/couple-closing-real-estate-contract-with-real-estate-agent.jpg?s=612x612&w=0&k=20&c=hfrGSvu-4QJjJm5mGFtdp5M4EdhBM_piLTZFadi7ygU=",
          imageAlt: "Home Selling",
        },
        {
          title: "Rentals & Landlords",
          description:
            "Assistance for renters and property owners alike.",
          imageSrc: "https://media.istockphoto.com/id/2188950033/photo/couple-discussing-details-of-a-house-with-their-real-estate-agent-while-looking-at-a-brochure.jpg?s=612x612&w=0&k=20&c=1FLQQsEjl4WwCDMcjP-i7u5ZrFEgIknYN_Obdc1lXc0=",
          imageAlt: "Rental Assistance",
        },
      ],
      otherServicesTitle: "Additional Offerings",
      otherServicesList: [
        "Free Home Value Reports",
        "Market Trend Analysis",
        "Relocation Services",
        "Bilingual Guidance",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://images.marketleader.com/MarketingImages/76/2405376_normal.jpg",
        alt: "Islayne Richart",
      },
      aboutText: [
        "Islayne Richart is a bilingual real estate agent with American Realty of PSL, LLC, serving Port St. Lucie and surrounding areas.",
        "With a proven track record and personalized support, she helps clients buy, sell, and rent properties with ease and confidence.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "American Realty of PSL Logo",
      businessName: "American Realty of PSL, LLC",
      contact: {
        phone: "7573003774",
        phoneLabel: "(757) 300‑3774",
        email: "islaynerichart@gmail.com",
        website: "https://www.islaynesellsrealestate.com/",
        address: "1980 SW Bayshore Blvd, Port St. Lucie, FL 34984",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "1980 SW Bayshore Blvd, Port St. Lucie, FL 34984",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3650.123456789!2d-80.358!3d27.280!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2s1980+SW+Bayshore+Blvd%2C+Port+St.+Lucie%2C+FL+34984!5e0!3m2!1sen!2sus!4v1718730000000!5m2!1sen!2sus",
    },
  },
};

export default config;
